import { render } from "./EditpasswordView.vue?vue&type=template&id=80f93612"
import script from "./EditpasswordView.vue?vue&type=script&lang=js"
export * from "./EditpasswordView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__